import { later } from '@ember/runloop';
import UnhandledFormErrorModalComponent from 'sh-www/components/modals/unhandled-form-error';
import { showModal } from 'sh-www/utils/modal-controls';
import scrollIntoView from 'scroll-into-view-if-needed';

/**
 * Convert an errors object into a flat array of error message strings
 *
 * @param {Object} errors
 * @returns {string[]}
 */
export const flattenErrorValues = (errors) => {
  return Object.values(errors)
    .flatMap(
      (value) => Boolean(value)
        ? Array.isArray(value) ? value : [value]
        : []
    );
}

/**
 * Scroll to the first error present in the DOM
 *
 * @param {Object} scope
 * @param {Object} errors
 * @param {Object} [options] - Additional options for errors being set.
 * @param {HTMLElement} [options.scrollToErrorSearchArea=document.body] - Area in which query selection occurs.
 */
export const scrollToError = (scope, errors, options = {}) => {
  const {
    scrollToErrorSearchArea = document.body,
  } = options;

  later(null, () => {
    // find the first targetable error on the page
    const erroneousElement = scrollToErrorSearchArea.querySelector('.GLM-error');

    // scroll to error if found on the page
    if (erroneousElement) {
      scrollIntoView(erroneousElement, {
        scrollMode: 'if-needed',
        block: 'center',
        inline: 'nearest',
      });
    } else {
      // flatten all valid error values into single array
      const errorValues = flattenErrorValues(errors);

      // check that the errors object contains an error value
      if (errorValues.length === 0) {
        return;
      }

      // show unhandled error in modal until fix is made
      showModal(scope, UnhandledFormErrorModalComponent, {
        errorValues,
      });
    }
  }, 100);
};
